import { render, staticRenderFns } from "./LoopsGrafting.vue?vue&type=template&id=2288725e&scoped=true&"
import script from "./LoopsGrafting.vue?vue&type=script&lang=js&"
export * from "./LoopsGrafting.vue?vue&type=script&lang=js&"
import style0 from "./LoopsGrafting.vue?vue&type=style&index=0&id=2288725e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2288725e",
  null
  
)

export default component.exports